var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.calendar/app/components/calendars-list/items/item/configuration/configuration-list.pug");
module.exports = (req['default'] || req).apply(req, [])